// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
export default { DashboardOutlined };
